// **** import modules ****
import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";


// **** process ****
export default {
	init(enebleCloseMenuByScroll) {
		const components = window.app.components;
		
		this.enebleCloseMenuByScroll = !!enebleCloseMenuByScroll;
		this.$element = $("#site_nav");
		this.$content = this.$element.children(".content");
		
		this.$switch = $("#nav_switch");
		this.$switch.$parent = this.$switch.parent();
		
		this.$switch.on("change", (e, isTrigger) => {
			const isOpen = e.target.checked;
			
			this.$switch.$parent.toggleClass("is-open", isOpen);
			
			if( isTrigger && u_.isString(isTrigger) ) {
				this.$switch.$parent.addClass(isTrigger);
			}
			
			this.$content.css({
				"max-height": !isOpen ? "" : window.innerHeight - components.$siteHeader.outerHeight() + 60
			});
			
			if(this.enebleCloseMenuByScroll) {
				// [close menu by scroll]
				if(isOpen) {
					const scrollTopOnOpen = components.$window.scrollTop();
					components.$window.on("scroll.closeMenu", e => this._closeMenuByScroll(scrollTopOnOpen));
					
				} else {
					components.$window.off(".closeMenu");
				}
			} else {
				components.$body.css("overflow", isOpen ? "hidden" : "");
			}
		}).prop("checked", false).trigger("change", ["is-ready"]);
		
		components.$siteNav = this.$element;
		
		return this;
	},
	
	_closeMenuByScroll(scrollTopOnOpen) {
		const abs = Math.abs(window.app.components.$window.scrollTop() - scrollTopOnOpen);
		if(abs > 80) {
			this.$switch.prop("checked", false).trigger("change", [true]);
		}
		return this;
	}
};

